<mat-card>
  <mat-toolbar-row>
    <h3>{{ 'Static Routes' | translate }}</h3>

    <div class="actions action-icon">
      <button mat-button color="default" [ixTest]="['add-static-route']" (click)="doAdd()">
        {{ 'Add' | translate }}
      </button>
    </div>
  </mat-toolbar-row>
  <mat-card-content>
    <ix-table2
      [ix-table2-empty]="!dataProvider.rows.length"
      [emptyConfig]="emptyService.defaultEmptyConfig(emptyType$ | async)"
    >
      <thead
        ix-table-head
        [columns]="columns"
        [dataProvider]="dataProvider"
      ></thead>
      <tbody
        ix-table-body
        [columns]="columns"
        [dataProvider]="dataProvider"
      >
        <ng-template
          ix-table-cell
          [columnIndex]="2"
          [dataProvider]="dataProvider"
          let-route
        >
          <div class="actions">
            <button
              mat-icon-button
              [attr.aria-label]="'Edit' | translate"
              [matTooltip]="'Edit' | translate"
              [ixTest]="['edit', route.id]"
              (click)="doEdit(route)"
            ><ix-icon name="mdi-pencil"></ix-icon></button>
            <button
              mat-icon-button
              [attr.aria-label]="'Delete' | translate"
              [matTooltip]="'Delete' | translate"
              [ixTest]="['delete', route.id]"
              (click)="doDelete(route)"
            ><ix-icon name="mdi-delete"></ix-icon></button>
          </div>
        </ng-template>
      </tbody>
    </ix-table2>
    <ix-table-pager-show-more [pageSize]="4" [dataProvider]="dataProvider"></ix-table-pager-show-more>
  </mat-card-content>
</mat-card>
